/**
 * KAN-788, KAN-880: имена параметров адреса таблицы CRM для атрибута и места
 * (город, организация). Одно место для хука фильтров (useCrmTableUrlFilters)
 * и перехода из "Лиды по дням" (lib/crmStats).
 */
export const CRM_LOCATION_PARAM = { city: 'city', company: 'company', companyId: 'company_id' } as const;

export const CRM_ATTRIBUTE_PARAM = { attr: 'attr', value: 'attr_value' } as const;
